<template>
  <save-dialog
    :title="title"
    :dialog="dialog"
    :form="form"
    :route="route"
    :edit="true"
    :hasMore="false"
    :more="false"
    :bus="dialogBus">
    <template slot="content">
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            v-model="form.name"
            v-validate="'required|max:100'"
            data-vv-name="name"
            data-vv-as="nombre"
            :error-messages="errors.collect('name')"
            label="Nombre"
            color="black">
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md6 pr-5>
          <v-select
            v-model="form.type"
            v-validate="'required'"
            data-vv-name="tipo"
            :error-messages="errors.collect('tipo')"
            :items="types"
            label="Tipo"
            color="black"
            autocomplete>
          </v-select>
        </v-flex>
        <v-flex md6>
          <v-text-field
            v-model="form.template_code"
            v-validate="'required|max:100'"
            data-vv-name="template_code"
            data-vv-as="código"
            :error-messages="errors.collect('template_code')"
            label="Código"
            color="black">
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md12>
          <v-menu offset-y class="w-100" max-height="250px">
            <v-text-field
              v-model="form.category"
              @input="findCategory"
              slot="activator"
              label="Categoria"
              item-text="category"
              item-value="category"
              v-validate="'required'"
              data-vv-name="category"
              data-vv-as="categoria"
              :error-messages="errors.collect('category')"
              color="black">
            </v-text-field>
            <v-list v-if="categories.length > 0">
              <v-list-tile v-for="item in categories" :key="item.key" @click="form.category = item.category">
                <v-list-tile-title>{{ item.category }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
            <v-list v-else>
              <v-list-tile>
                <v-list-tile-title class="grey--text">No se encontraron registros</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>
    </template>
  </save-dialog>
</template>

<script>
import EventBus from '@/event-bus';
import SaveDialog from '@/components/global/SaveDialog';
import saveDialogMixin from '@/mixins/saveDialog';

export default {
  components: {
    SaveDialog,
  },
  mixins: [
    saveDialogMixin,
  ],
  created() {
    EventBus.$on(this.dialogBus.modalOpened, () => {
      this.axios.get('/templates/categories').then((response) => {
        this.categories = response.data;
        this.saveCategories = response.data;
      });
    });
  },
  data() {
    return {
      categories: [],
      saveCategories: [],
      types: [
        {
          text: 'Llamada',
          value: 'llamada',
        },
      ],
      form: {
        type: '',
        template_code: '',
        name: '',
        category: '',
      },
      dialogBus: {
        modalOpened: 'modalOpenedBotTemplate',
        showMore: 'showMoreBotTemplate',
        editItem: 'editItemBotTemplate',
        closeModal: 'closeModalBotTemplate',
        openRightDrawer: 'openRightDrawerBotTemplate',
      },
      route: 'bot_templates',
      showName: 'Plantilla',
      fields: 'name,template_code,status,type,category',
    };
  },
  methods: {
    findCategory(val) {
      if (val !== '') {
        let result = []; // eslint-disable-next-line
        result = this.saveCategories.filter(item => item.category.toString().toLowerCase().indexOf(val.toString().toLowerCase()) > -1);
        this.categories = result;
      } else {
        this.categories = this.saveCategories;
      }
    },
  },
  watch: {
    text(newVal) {
      this.form.text = newVal;
    },
    'form.text'(newVal, oldVal) { // eslint-disable-line
      if (!oldVal || !newVal) {
        this.text = newVal;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/templateV2/EditBot.vue